import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getProCount} from '../../../apis/user/getProCount'

const useQueryProCount = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.user.getProCount(),
        queryFn: async () => {
            const {data} = await getProCount()
            return {data}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryProCount
